import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/RefreshProfileAccountAvailability.graphql';
import { Query, QueryrefreshProfileAccountAvailabilityArgs } from '../../__generated__/globalTypes';

export const useRefreshProfileAccountAvailabilityQuery = (
  options?: QueryHookOptions<Query, QueryrefreshProfileAccountAvailabilityArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryrefreshProfileAccountAvailabilityArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useRefreshProfileAccountAvailabilityLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryrefreshProfileAccountAvailabilityArgs>
): QueryResult<Query, QueryrefreshProfileAccountAvailabilityArgs> & {
  getRefreshProfileAccountAvailability: LazyQueryExecFunction<Query, QueryrefreshProfileAccountAvailabilityArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getRefreshProfileAccountAvailability, result] = useLazyQuery<
    Query,
    QueryrefreshProfileAccountAvailabilityArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getRefreshProfileAccountAvailability, ...result };
};

export const useRefreshProfileAccountAvailabilityPromiseQuery = () => {
  const client = useApolloClient();

  const getRefreshProfileAccountAvailability = useCallback(
    (options?: Omit<QueryOptions<QueryrefreshProfileAccountAvailabilityArgs, Query>, 'query'>) =>
      client.query<Query, QueryrefreshProfileAccountAvailabilityArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getRefreshProfileAccountAvailability };
};
// Suspense Query Hooks
export const useRefreshProfileAccountAvailabilitySuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryrefreshProfileAccountAvailabilityArgs>
) => {
  const result = useSuspenseQuery<Query, QueryrefreshProfileAccountAvailabilityArgs>(QUERY, {
    ...options
  });

  return result;
};
